import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionWrapper } from "../../../Styles/style";

import Incognitomode from "../../../../assets/images/Incognitomode.png";
const MainGrid = styled(Grid)`
  padding: 80px 0 30px;
  justify-content: center;
  text-align: LEFT;
`;
const GridImg = styled(Grid)`
  text-align-last: right;
  @media screen and (max-width: 599px) {
    text-align-last: unset;
    padding: 20px 0;
  }
`;
const GridText = styled(Grid)`
  padding: 80px 0 0;
`;
const LearnBuutt = styled.a`
  border: 1px solid ${(props) => props.theme.textSecondary};
  color: ${(props) => props.theme.textSecondary};
  padding: 7px 20px;
  text-decoration: none;
`;
const MetAMskimg = styled.img`
  width: 100%;
  max-width: 350px;
`;

const S3_Features = () => {
  const theme = useTheme();
  return (
    <div>
      <SectionWrapper bgcolor={theme.bgSecondary} p="4rem 0" id="features">
        <Container maxWidth="xl">
          <MainGrid container rowGap={2}>
            <GridText
              item
              xs={12}
              md={5}
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
              data-aos-delay="300"
              data-aos-offset="0"
              data-aos-duration="1000"
            >
              <SectionHeading
                color={theme.textSecondary}
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="300"
                data-aos-offset="0"
                data-aos-duration="1000"
              >
                Incognito Mode
              </SectionHeading>
              {/* <P p="5px 0 10px" m="0" color={theme.textSecondary} data-aos="zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="700"
                                data-aos-offset="0"
                                data-aos-duration="300"><b>Privacy On Ethereum, BNB Chain, Polygon And Avalanch C-Chain</b></P> */}
              <P
                color={theme.textSecondary}
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="300"
                data-aos-offset="0"
                data-aos-duration="1000"
              >
                Incognito enhances your transaction privacy on Ethereum, BNB,
                and multiple other blockchains. Your financial activities remain
                confidential, shielding you from prying eyes.
              </P>
              <LearnBuutt
                href="#"
                target="blank"
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="800"
                data-aos-offset="0"
                data-aos-duration="1000"
              >
                Learn More
              </LearnBuutt>
            </GridText>

            {/* <Grid item xs={2} /> */}
            <GridImg
              item
              xs={12}
              md={5}
              data-aos="zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-offset="0"
              data-aos-duration="1000"
            >
              <MetAMskimg src={Incognitomode} />
            </GridImg>
          </MainGrid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S3_Features;
